__turbopack_context__.v({
  "brand": "spinner-module__k8XRpa__brand",
  "sizeLg": "spinner-module__k8XRpa__sizeLg",
  "sizeMd": "spinner-module__k8XRpa__sizeMd",
  "sizeSm": "spinner-module__k8XRpa__sizeSm",
  "sizeXl": "spinner-module__k8XRpa__sizeXl",
  "spin": "spinner-module__k8XRpa__spin",
  "spinner": "spinner-module__k8XRpa__spinner",
});
